/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { useAppContext } from "../../../../Basis/Components/AppContext";
import { useAppRollenContext } from "../../../../Basis/Components/AppRollenContext";
import { environment } from "../../../../Basis/environment";
import { XIcon } from "../../../../Basis/FontAwesome";
import MitteilungVersionUtil from "../../Commands/MitteilungVersionUtil";
import SetzeMitteilungenAngezeigt from "../../Commands/SetzeMitteilungenAngezeigt";
import SetzeMitteilungenGelesen from "../../Commands/SetzeMitteilungenGelesen";
import LazyLadeBannerMitteilungen from "../../Queries/LazyLadeBannerMitteilungen";
import Mitteilung from "../../Queries/Mitteilung";
import variablesScss from "../../../../Basis/Themes/variables.module.scss";

export default function BannerMitteilungen() {
    const [mitteilungen, setMitteilungen] = useState<Mitteilung[]>([]);
    const appContext = useAppContext();
    const pollingIntervall = appContext.options.pollingIntervallInSeconds * 1000;
    const appRollenContext = useAppRollenContext();
    const istNutzend = appRollenContext.istNutzend;
    const lazyLadeBannerMitteilungen = new LazyLadeBannerMitteilungen(mitteilungenGeladen);
    const setzeMitteilungenAngezeigt = new SetzeMitteilungenAngezeigt();
    const setzeMitteilungenGelesen = new SetzeMitteilungenGelesen();

    function mitteilungenGeladen(mitteilungen: Mitteilung[]) {
        setMitteilungen(mitteilungen ?? []);
        if (mitteilungen && mitteilungen.length > 0) {
            setzeMitteilungenAngezeigt.execute({ mitteilungen: MitteilungVersionUtil.mitteilungenZuMitteilungVersionen(mitteilungen) });
        }
    }

    function setzeBannerMitteilungGelesen(mitteilung: Mitteilung) {
        setzeMitteilungenGelesen.execute({ mitteilungen: MitteilungVersionUtil.mitteilungenZuMitteilungVersionen([mitteilung]) }).then(() => {
            lazyLadeBannerMitteilungen.refetch();
        });
    }

    useEffect(() => {
        if (!istNutzend || environment.istBuchungsportal) {
            lazyLadeBannerMitteilungen.stopPolling();
            return;
        }

        lazyLadeBannerMitteilungen.execute();
        lazyLadeBannerMitteilungen.startPolling(pollingIntervall);
    }, [pollingIntervall, istNutzend]);

    return (
        <>
            {(mitteilungen.length > 0) && (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                    }}
                >
                    {mitteilungen.map((mitteilung) => (
                        <Box
                            sx={{
                                display: "flex",
                                backgroundColor: variablesScss.colorsTertiaryMain,
                                width: "100%",
                                alignItems: "center",
                                padding: ".25rem .5rem",
                                fontSize: "0.875rem",
                                color: variablesScss.colorsWhite,
                                borderBottom: `1px solid ${variablesScss.colorsTertiaryLight}`,
                            }}
                            key={mitteilung.mitteilungId}
                        >
                            <Box
                                sx={{ flex: "1 1 auto" }}
                                dangerouslySetInnerHTML={{ __html: mitteilung.text }}
                            ></Box>
                            <IconButton
                                sx={{
                                    height: "2rem",
                                    width: "2rem",
                                    marginLeft: "auto",
                                    color: variablesScss.colorsWhite,
                                }}
                                onClick={() => setzeBannerMitteilungGelesen(mitteilung)}
                                size="large">
                                <XIcon />
                            </IconButton>
                        </Box>
                    ))}
                </Box>
            )}
        </>
    );
}
